import gql from 'graphql-tag';

export const RUN_TENSORBOARD_QUERY = gql`
  query RunTensorboard(
    $projectName: String!
    $entityName: String!
    $runName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        servicesAvailable {
          tensorboard
        }
      }
    }
  }
`;
